import { Injectable } from '@angular/core';
import { IAppState } from '@myStore/app.state';
import {
  CloseWorkAppealRequest,
  CloseWorkAppealSuccess,
  EStudentResultsViewActions,
  GetStudentResultsFailure,
  GetStudentResultsRequest,
  GetStudentResultsSuccess,
  WorkAppealFailure,
  WorkAppealRequest,
  WorkAppealSuccess,
} from '@myStore/student-results-view/student-results-view.actions';
import { GetWorkReview } from '@myStore/student-works/student-works.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { StudentResultsViewService } from '@services/student-results-view/student-results-view.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class StudentResultsViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _studentResultsViewService: StudentResultsViewService
  ) {}

  $getResults = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetStudentResultsRequest>(
          EStudentResultsViewActions.GetStudentResultsRequest
        ),
        switchMap(action => {
          return this._studentResultsViewService
            .get(action.groupId, action.userId)
            .pipe(
              map(results => {
                this._store.dispatch(new GetStudentResultsSuccess(results));
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При получении результатов возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(new GetStudentResultsFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $createAppeal = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<WorkAppealRequest>(EStudentResultsViewActions.WorkAppealRequest),
        switchMap(work => {
          return this._studentResultsViewService
            .postAppealReview(work.reviewId, work.text)
            .pipe(
              map(() => {
                this._store.dispatch(new WorkAppealSuccess());
                this._toastr.success('Аппеляция успешно подана');
                this._store.dispatch(new GetWorkReview(work.reviewId));
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При подачи апелляции  возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(new WorkAppealFailure(err.error));
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $closeAppeal = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CloseWorkAppealRequest>(
          EStudentResultsViewActions.CloseWorkAppealRequest
        ),
        switchMap(work => {
          return this._studentResultsViewService
            .closeAppealReview(work.reviewId, work.reviewer)
            .pipe(
              map(() => {
                this._store.dispatch(new CloseWorkAppealSuccess());
                this._toastr.success('Аппеляция закрыта');
                this._store.dispatch(new GetWorkReview(work.reviewId));
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При закрытии апелляции возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(new WorkAppealFailure(err.error));
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );
}
